import React, { useState, useRef, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

const QueryInput = (
    { label, queryString, setQueryString, handleSubmit }:
        {
            label: string,
            queryString: string,
            setQueryString: (queryString: string) => void,
            handleSubmit: () => void,
        }) => {

    const [cursorPosition, setCursorPosition] = useState<number | null>(null);
    const textareaRef = useRef<HTMLTextAreaElement | null>(null);
    const inputRef = useRef<HTMLInputElement | null>(null);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const target = event.target;
        setCursorPosition(target.selectionStart);
        setQueryString(target.value);
    };

    const handleKeyDown = (event: React.KeyboardEvent) => {
        const target = event.target as HTMLTextAreaElement | HTMLInputElement;
        const isCorrectTagName= target.tagName === 'TEXTAREA' || target.tagName === 'INPUT'
        if (isCorrectTagName && event.key === 'Enter') {
                event.preventDefault();
                handleSubmit();
        }
    };

    useEffect(() => {
        if (cursorPosition !== null) {
            if (textareaRef.current) {
                textareaRef.current.setSelectionRange(cursorPosition, cursorPosition);
            }
            if (inputRef.current) {
                inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
            }
        }
    }, [queryString, cursorPosition]);

    const isLargeQuery = queryString.split('\n').length > 1 || queryString.length > 100;

    return (
        <Box
            component="form"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                width: '100%'
            }}
            pl={3.5}
            pr={3.5}
            noValidate
            display="flex"
            justifyContent="space-between"
            autoComplete="off"
        >
            <Typography
                variant="body1"
                style={{ color: 'grey' }}
                mt={3}
            >
                {label}
            </Typography>
            {isLargeQuery ? (
                <TextareaAutosize
                    ref={textareaRef}
                    id="query-input"
                    aria-label="Enter Query"
                    minRows={3}
                    autoFocus
                    style={{
                        width: '96vw',
                        padding: '8px',
                        fontSize: '16px',
                        marginBottom: '8px',
                        fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif`
                    }}
                    value={queryString}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                />
            ) : (
                <TextField
                    inputRef={inputRef}
                    id="query-input"
                    label="Enter Query"
                    variant="outlined"
                    value={queryString}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    fullWidth={true}
                />
            )}
            <Button
                variant="outlined"
                onClick={handleSubmit}
                style={{ marginTop: '8px', marginBottom: '16px', textTransform: 'none' }}
            >
                <Typography
                    variant="caption"
                >
                    Submit Query
                </Typography>
            </Button>
        </Box>
    );
}

export default QueryInput;